export default function getLetterFromIndex(index: number) {
  return String.fromCharCode(97 + index).toUpperCase();
}